import { type Event, type SeedAssignment } from '@clubspark-node/clubspark-tennis-types';
import { scaleConstants } from 'tods-competition-factory';

import { type ParticipantInterface } from 'typedefs/store/tmxTypes';

const { SEEDING } = scaleConstants;

export const getSeeds = (
  event: Event,
  participants: ParticipantInterface[],
  seedAssignments: SeedAssignment[],
  flightDrawId?: string,
  isQualifying?: boolean,
) => {
  return participants?.map((participant) => {
    const scaleAttributes = {
      eventType: event.eventType,
      scaleType: SEEDING,
      scaleName: getSeedingScaleName(event.eventId, flightDrawId, isQualifying),
    };
    const scaleItemKey = `SCALE.${scaleAttributes.scaleType}.${scaleAttributes.eventType}.${scaleAttributes.scaleName}`;
    const scaleItem = participant?.timeItems?.find((item) => item?.itemType === scaleItemKey);
    const assignedSeed = seedAssignments?.find(
      (assignment) => assignment?.participantId === participant?.participantId,
    );
    // only use seedScale values if there are no seedAssignments (meaning no draw structure or seeds not used in draw structure)
    const seedValue =
      seedAssignments && seedAssignments.length > 0 ? assignedSeed?.seedValue || '' : scaleItem?.itemValue;

    return {
      participantId: participant?.participantId,
      scaleItem: {
        scaleType: SEEDING,
        scaleName: getSeedingScaleName(event.eventId, flightDrawId, isQualifying),
        eventType: event.eventType,
        scaleValue: seedValue || '',
      },
    };
  });
};

export const getSeedingScaleName = (eventId: string, flightDrawId: string, isQualifying?: boolean) =>
  isQualifying ? `q-${flightDrawId || eventId}` : flightDrawId || eventId;
